import { ColumnVisibilityItem } from "providers/Auth";
import { LeadColumnId } from "../constants";

const COLUMNS_HIDDEN_FOR_EXISTING_VIEWS = new Set<string>([
  LeadColumnId.PrescreeningResult
]);

// Appends any column that didn't exist when the stored blob was written.
export const mergeColumnsWithDefaults = (
  savedColumns: ColumnVisibilityItem[] | undefined,
  defaults: ColumnVisibilityItem[]
) => {
  if (!savedColumns) return defaults;

  const savedColumnIds = new Set(savedColumns.map((col) => col.id));
  const mergedColumns = [...savedColumns];

  defaults.forEach((defaultCol) => {
    if (savedColumnIds.has(defaultCol.id)) return;

    mergedColumns.push(
      COLUMNS_HIDDEN_FOR_EXISTING_VIEWS.has(defaultCol.id)
        ? { ...defaultCol, checked: false }
        : defaultCol
    );
  });

  return mergedColumns;
};
